import React, {
	forwardRef,
	useEffect,
	useRef
} from 'react';
import PropTypes from 'prop-types';

const IndeterminateCheckbox = forwardRef( ( {
	indeterminate,
	...rest
}, ref ) => {
	const defaultRef = useRef();
	const resolvedRef = ref || defaultRef;

	useEffect( () => {
		resolvedRef.current.indeterminate = indeterminate;
	}, [
		resolvedRef,
		indeterminate
	] );

	return (
		<>
			<input
				type="checkbox"
				ref={ resolvedRef }
				{ ...rest }
			/>
		</>
	);
} );

IndeterminateCheckbox.displayName = 'IndeterminateCheckbox';

IndeterminateCheckbox.propTypes = { indeterminate: PropTypes.bool };

export default IndeterminateCheckbox;
